module.exports = __webpack_public_path__ + "static/media/lunar-details.d2ec20c3.jpg";